import React, { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';
import { RoleDisplayFormatter } from 'ui';

const UserInfoSidebarBottom = () => {
   const authRedux = useSelector((state) => state.authReducer.loggedInUser);
   const [organization, setOrganization] = useState('');
   useEffect(() => {
      if (authRedux.organizations && authRedux.organizationId) {
         const org = authRedux.organizations.find((item) => item.id === +authRedux.organizationId);
         if (org) {
            setOrganization(org.name);
         }
      }
   }, [authRedux.organizationId, authRedux.organizations]);
   useEffect(() => {
      if (authRedux) {
         try {
            window.fcWidget.setExternalId(authRedux.userId);
            window.fcWidget.user.setFirstName(`${ authRedux.fname } ${ authRedux.lname }`);
            window.fcWidget.user.setEmail(authRedux.email);
            window.fcWidget.user.setProperties({
               plan: authRedux.accountType,
               orgId: authRedux.organizationId,
            });
         } catch (e) { }
      }
   }, [authRedux]);
   return (
      <div className='sidebar-bottom d-none d-md-block border-top bg-white pl-4'>
         <div className='media'>
            <div className='media-body'>
               <div>{`${ authRedux.fname } ${ authRedux.lname }`}</div>
               <div>{authRedux.email}</div>
               <div>{organization}</div>
               <div><RoleDisplayFormatter roles={authRedux.roles} /></div>
            </div>
         </div>
      </div>
   );
};

export default UserInfoSidebarBottom;
